import React, { useContext } from 'react';
import classnames from 'classnames';

import StencilCanvas from './StencilCanvas';
import StencilBuilderSteps from './StencilBuillderSteps';
import StencilUndo from './StencilUndo';
import type { TStencilStore } from '../../types/Stencil';
import { useSelector } from 'react-redux';
import StencilToolbox from '@src/components/stencils/StencilToolbox';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

import KeyBindingRedo from '../wysiwyg_editor/key_bindings/redo';
import KeyBindingUndo from '../wysiwyg_editor/key_bindings/undo';

type TProps = {
  onNextStep: () => void;
};

function StencilFormCreate({ onNextStep }: TProps) {
  const cancelRedirectUrl = useSelector(
    (state: TStencilStore) => state.settings.cancelRedirectUrl
  );
  const allPicturesSelected = useSelector(
    (state: TStencilStore) => state.submission.allImagesPopulated
  );
  const { activeToolboxTab: activeTab } = useContext(WysiwygEditorStateContext);
  const canUndo = useSelector(
    (state: TStencilStore) => state.submission.history.undo.length > 0
  );
  const canRedo = useSelector(
    (state: TStencilStore) => state.submission.history.redo.length > 0
  );

  return (
    <div
      className={classnames(
        'stencil-new',
        'stencil-form-page',
        'stencil-form-page--visible',
        { 'stencil-new--toolbox-open': activeTab !== null }
      )}
    >
      <StencilBuilderSteps />
      <StencilUndo />
      <StencilToolbox />
      <StencilCanvas />
      <KeyBindingRedo canRedo={canRedo} />
      <KeyBindingUndo canUndo={canUndo} />

      <div className="stencil-navigation">
        <a
          className="stencil-navigation-link stencil-navigation-link--cancel"
          href={cancelRedirectUrl}
        >
          Cancel
        </a>
        <button
          className="wysiwyg-editor-button wysiwyg-editor-button--preview"
          type="button"
          onClick={onNextStep}
          disabled={!allPicturesSelected}
        >
          Finish & Preview
        </button>
      </div>
    </div>
  );
}

export default StencilFormCreate;
